module.exports = __webpack_public_path__ + "static/300x250-5f09346aeae7d36074519d558b99bdb6.jpg";